import { Dropdown } from "react-bootstrap";
import StyledToggle from "./StyledToggle";

interface YearDropdownProps {
  year: number | null;
  onYearChange: (year: number) => void;
  years: number[];
  yearLabels?: Record<number, string>;
}

const YearDropdown = ({
  year,
  onYearChange,
  years,
  yearLabels,
}: YearDropdownProps) => {
  const handleSelect = (selectedYear: string | null) => {
    if (!selectedYear) return;
    onYearChange(Number(selectedYear));
  };

  const getLabel = (y: number) => yearLabels?.[y] ?? y;

  return (
    <Dropdown onSelect={handleSelect}>
      <StyledToggle
        className="view-tools-dropdown fs-6 bg-light text-black"
        size="lg"
      >
        <span className="toggle-text">
          {year === null || years.length === 0 ? "Select Year" : getLabel(year)}
        </span>
      </StyledToggle>

      <Dropdown.Menu className="w-100 fs-6">
        {years.map((y) => (
          <Dropdown.Item key={y} eventKey={String(y)} active={y === year}>
            {getLabel(y)}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default YearDropdown;
